import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddAccountActions from './add-account.actions';

export const addAccountFeatureKey = 'addAccount';

export interface AddAccountState {
   callState: CallState;
}

export const initialState: AddAccountState = {
   callState: LoadingState.Init,
};

const addAccountReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddAccountActions.createAccount, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddAccountActions.createAccountSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddAccountActions.createAccountFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddAccountState | undefined, action: Action) {
   return addAccountReducer(state, action);
}
